// extracted by mini-css-extract-plugin
module.exports = {"search":"Search-module--search--2TcqG","result":"Search-module--result--34qbn"};